import { render, staticRenderFns } from "./gzhArticleList.vue?vue&type=template&id=9d23173e&"
import script from "./gzhArticleList.vue?vue&type=script&lang=js&"
export * from "./gzhArticleList.vue?vue&type=script&lang=js&"
import style0 from "./gzhArticleList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports